import { useTranslation } from 'react-i18next';
import { PmsPasswordDialog } from './PmsWorkParts.js';

/**
 * Void ve Correct penceresi (K14) [NR496 4.5.3f]: raporlanmış kayıt değişmez. "Void" kaydı
 * gerekçeyle iptal eder (iade sonrası iptal History'de "Superseded after return"); "Correct" aynı
 * gerekçeyle eskisini iptal edip düzeltilmiş yeni kaydı tek işlemde yazar. Parola yalnız şirket
 * ayarı açıkken istenir (ADR 0075).
 */
export function VoidCorrectDialog({
  opened,
  mode,
  woNo,
  onClose,
  onConfirm,
}: {
  opened: boolean;
  mode: 'void' | 'correct';
  woNo: string;
  onClose: () => void;
  /** `password` yalnız girildiyse. */
  onConfirm: (input: { reason: string; password?: string }) => Promise<void>;
}) {
  const { t } = useTranslation();
  const k = (key: string) => t(`pms.work.void.${key}`, { wo: woNo });
  return (
    <PmsPasswordDialog
      opened={opened}
      title={mode === 'void' ? k('voidTitle') : k('correctTitle')}
      body={mode === 'void' ? k('voidBody') : k('correctBody')}
      reason="required"
      reasonLabel={k('reason')}
      confirmLabel={mode === 'void' ? k('void') : k('submitCorrection')}
      danger={mode === 'void'}
      reauthKind="pms_work_record"
      note={mode === 'void' ? k('voidNote') : k('correctNote')}
      onClose={onClose}
      onConfirm={async (input) => {
        await onConfirm(input);
        return null;
      }}
    />
  );
}
